import { createContext, useState } from "react"

const Context = createContext();

const {Provider} = Context;

function ContextProvider({children}) {
    const [modalData,setModalData] = useState({});
    const [showModal,setShowModal] = useState(false)

    const handleShowModal = (state, data) => {
        setModalData(data)
        setShowModal(state)
    }

    return (
        <Provider
            value={{
                handleShowModal,
                modalData,
                showModal
            }}
        >
            {children}
        </Provider>
    )
} 

export {Context,ContextProvider}